import { Staff as PBStaff } from "gen/company/models_pb"

export class Staff {
  private staff: PBStaff

  private constructor(staff: PBStaff) {
    this.staff = staff
  }

  static fromPB(pbStaff: PBStaff) {
    return new Staff(pbStaff)
  }

  get fullName(): string {
    return `${this.staff.firstName} ${this.staff.lastName}`
  }
}
